import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { RECOVERY_ROUTE, REGISTRATION_ROUTE } from '../../utils/consts';
import { createEmail, createEmailStatus, createPassword, createPasswordStatus, createPhone, createPhoneStatus } from '../../redux/actions/userActions';
import SelectAuth from '../../components/SelectAuth';
import AuthWrapper from '../../containers/AuthWrapper';
import FieldInput from '../../components/FieldInput';
import useCheck from '../../hooks/authorization.hook';
import SelectRecovery from '../../components/SelectRecovery';

const LogIn = ({ phone, email, password }) => {

    const [activePhone, setActive] = useState(true);
    const [btnDisabled, setBtnDisabled] = useState(true);
    const { phoneCheck, emailCheck, doLogin } = useCheck();
    const dispatch = useDispatch();

    useEffect(async () => {
        dispatch(createPhoneStatus(await phoneCheck(phone)));
    }, [phone.value]);

    useEffect(async () => {
        dispatch(createEmailStatus(await emailCheck(email.value, phone)));
    }, [email.value]);

    useEffect(() => {
        password.value.length >= 6 && (phone.validation || email.validation) ? setBtnDisabled(false) : setBtnDisabled(true);
    }, [password.value, phone.validation, email.validation]);

    const login = async () => {
        const result = await doLogin(activePhone ? phone : email, password, 'auth', activePhone);
        dispatch(createPasswordStatus(result));
    };

    return (
        <Fragment>
            <AuthWrapper title='Вход в личный кабинет'>
                <div className="mb-3">
                    <SelectRecovery title='Тип входа' active={activePhone} func={setActive} />
                </div>
                <div className="mb-3">
                    {
                        activePhone ?
                            <FieldInput
                                id='phone'
                                type='tel'
                                name='phone'
                                mask={true}
                                value={phone.value}
                                placeholder='Ваш номер телефона'
                                onchange={e => dispatch(createPhone(e))}
                                validation={{ status: phone.validation, message: phone.message }}
                            />
                            :
                            <div className="mb-3">
                                <FieldInput
                                    id='email'
                                    type='email'
                                    name='email'
                                    value={email.value}
                                    placeholder='Ваш Email'
                                    onchange={e => dispatch(createEmail(e))}
                                    validation={{ status: email.validation, message: email.message }}
                                />
                            </div>
                    }
                </div>
                <div className="mb-3">
                    <FieldInput
                        id='password'
                        type='password'
                        name='password'
                        value={password.value}
                        placeholder='Ваш пароль'
                        onchange={e => dispatch(createPassword(e))}
                        validation={{ status: password.validation, message: password.message }}
                    />
                </div>
                <div className="d-flex justify-content-center justify-content-md-end mt-4">
                    <button onClick={login} className='btn btn_red btn_md' disabled={btnDisabled}>Войти</button>
                </div>
            </AuthWrapper>
            <SelectAuth
                titles={['Регистрация', 'Забыли пароль ?']}
                routes={[REGISTRATION_ROUTE, RECOVERY_ROUTE]}
            />
        </Fragment>
    );
};

const mapStateToProps = state => {
    return {
        phone: {
            value: state.user.phone,
            validation: state.user.phoneStatus.validation,
            message: state.user.phoneStatus.message
        },
        email: {
            value: state.user.email,
            validation: state.user.emailStatus.validation,
            message: state.user.emailStatus.message
        },
        password: {
            value: state.user.password,
            validation: state.user.passwordStatus.validation,
            message: state.user.passwordStatus.message
        }
    };
};

export default connect(mapStateToProps, null)(LogIn);

LogIn.propTypes = {
    phone: PropTypes.object,
    email: PropTypes.object,
    password: PropTypes.object,
};